import React from 'react';
import './styles.css';
import { DeviceSize, useWindowSize } from 'hooks/useWindowSize';
import Show from 'components/Functional/Show';
import cx from 'classix';
import { SubcategoryFilter } from '../../types/Category';
import { Link } from 'gatsby';

interface Props {
  subcategoryFilters: SubcategoryFilter[];
}

const SubcategoryGrid: React.FC<Props> = ({ subcategoryFilters }) => {
  const { deviceSize } = useWindowSize();

  const isMobile = deviceSize === DeviceSize.SMALL;

  return (
    <div className={cx('subcategory-list', isMobile && 'mobile')}>
      {subcategoryFilters.map(filter => {
        const { name, description, image } = filter;
        return (
          <Link
            key={name}
            to={filter.clpUrl}
            className={cx('subcategory-item', isMobile && 'mobile')}
          >
            <img src={image[0]?.url} alt={name} />
            <div className="subcategory-header">{name}</div>
            <Show when={!isMobile}>
              <div className="subcategory-description">{description}</div>
            </Show>
          </Link>
        );
      })}
    </div>
  );
};

export default SubcategoryGrid;